export const BASE_URL = "https://travelbee-api-production.onrender.com";
export const LOCAL_STORAGE_KEY = {
  user: "user",
  accessToken: "accessToken",
};

export const FORM_SCREEN_KEY={
  travelPackage:"travelPackage"
}